var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"paginator ml-auto mr-auto clearfix"},_vm._l((_vm.pages),function(i){return _c('li',{staticClass:"c-pointer no-select",class:{'active': i === _vm.page},on:{"click":function($event){return _vm.$emit('changed', i)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }